module.exports = __webpack_public_path__ + "img/耦合线.7a92e6b4.svg";